export const ApiErrorCode = {
  PasswordChangeRequired: 'PASSWORD_CHANGE_REQUIRED',
} as const;

export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];
